import React from 'react';
import { CheckIcon, BookIcon, BookOpenIcon, BookmarkIcon } from 'lucide-react';
export const PricingSection = () => {
  const pricingTiers = [{
    name: 'Digital Edition',
    price: '$19.97',
    icon: <BookIcon className="h-10 w-10" data-id="element-107" />,
    description: "Experience Ronaldo's journey in digital format",
    features: ['Complete digital version of the book', 'Instant access after purchase', 'Read on any device', 'Digital certificate of authenticity', 'Exclusive bonus chapter'],
    cta: 'Get Digital Access',
    popular: false,
    bgColor: 'bg-white',
    textColor: 'text-gray-800',
    buttonClass: 'bg-yellow-500 hover:bg-yellow-600 text-black'
  }, {
    name: 'Physical Edition',
    price: '$39.97',
    icon: <BookOpenIcon className="h-10 w-10" data-id="element-108" />,
    description: 'The complete story in premium print quality',
    features: ['High-quality printed copy', 'Elegant softcover binding', 'Premium photo inserts', 'Certificate of authenticity', 'Free worldwide shipping', 'Digital edition included'],
    cta: 'Order Physical Copy',
    popular: true,
    bgColor: 'bg-yellow-500',
    textColor: 'text-black',
    buttonClass: 'bg-black hover:bg-gray-800 text-white'
  }, {
    name: 'Limited Edition',
    price: '$94.97',
    icon: <BookmarkIcon className="h-10 w-10" data-id="element-109" />,
    description: "The collector's ultimate premium hardcopy",
    features: ['Numbered limited edition hardcover', 'Premium leather-bound finish', 'Gold-embossed cover with CR7 signature', 'Exclusive photographs not available elsewhere', 'Handwritten note from the curator', 'Display-worthy presentation box', 'Physical and digital certificates', 'Priority shipping with tracking'],
    cta: 'Secure Limited Edition',
    popular: false,
    bgColor: 'bg-black',
    textColor: 'text-white',
    buttonClass: 'bg-yellow-500 hover:bg-yellow-600 text-black'
  }];
  return <div id="pricing-section" className="py-20 bg-gradient-to-b from-white to-gray-100" data-id="element-110">
      <div className="container mx-auto px-4" data-id="element-111">
        <div className="text-center mb-16" data-id="element-112">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-113">
            Choose Your Legacy Edition
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-114">
            Select the edition that matches your collector's ambition. Each
            version is crafted with care to preserve Ronaldo's legacy.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-115">
          {pricingTiers.map((tier, index) => <div key={index} className={`rounded-xl shadow-lg overflow-hidden transform transition duration-300 hover:scale-105 ${tier.bgColor} ${tier.textColor} ${tier.popular ? 'ring-2 ring-yellow-500 ring-offset-4' : ''}`} data-id="element-116">
              {tier.popular && <div className="bg-yellow-600 text-white py-2 text-center font-bold text-sm" data-id="element-117">
                  MOST POPULAR CHOICE
                </div>}
              <div className="p-8" data-id="element-118">
                <div className="flex justify-center mb-4" data-id="element-119">{tier.icon}</div>
                <h3 className="text-xl font-bold text-center mb-2" data-id="element-120">
                  {tier.name}
                </h3>
                <div className="text-center mb-6" data-id="element-121">
                  <span className="text-4xl font-bold" data-id="element-122">{tier.price}</span>
                </div>
                <p className="text-center mb-6 text-sm" data-id="element-123">{tier.description}</p>
                <ul className="space-y-3 mb-8" data-id="element-124">
                  {tier.features.map((feature, i) => <li key={i} className="flex items-start" data-id="element-125">
                      <CheckIcon className="h-5 w-5 mr-2 flex-shrink-0 mt-0.5" data-id="element-126" />
                      <span className="text-sm" data-id="element-127">{feature}</span>
                    </li>)}
                </ul>
                <button onClick={() => window.location.href = 'https://www.voicesoffreedomus.com/cart/45188748673210:1'} className={`w-full py-3 px-4 rounded-md font-semibold transition-colors ${tier.buttonClass}`} data-id="element-128">
                  {tier.cta}
                </button>
              </div>
            </div>)}
        </div>
        <div className="mt-16 text-center" data-id="element-129">
          <p className="text-gray-600" data-id="element-130">
            <span className="font-semibold" data-id="element-131">Limited availability:</span> Once
            the Limited Edition copies are gone, they will never be reprinted.
          </p>
        </div>
      </div>
    </div>;
};